import { Outlet } from "react-router-dom";

const TheOutlet = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default TheOutlet;
